import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Footer from '../layouts/footer';

export default function ProfileEdit() {
        const navigate = useNavigate();
        const location = useLocation();
        const initial = location.state?.data || {};

        const [data, setData] = useState(initial);
        const [FName, setFName] = useState(initial.f_name || '');
        const [LName, setLName] = useState(initial.l_name || '');
        const [Email, setEmail] = useState(initial.email || '');
        const [Phone, setPhone] = useState(initial.phone || '');
        const [Gender, setGender] = useState(initial.gender || '');
        const [ValGender, setValGender] = useState(initial.gender_val || '');
        const [Image, setImage] = useState(initial.image || '');
        const [Image64, setImage64] = useState('');
        const [submitting, setSubmitting] = useState(false);

        const GenderOption = [
                { value: '1', label: 'Male' },
                { value: '2', label: 'Female' },
                { value: '3', label: 'Other' }
        ];

        const submit = async () => {
                if(!localStorage.getItem('token')){
                        window.location.replace('login');
                        return;
                }
                setSubmitting(true);
                try{
                        const payload = {
                                token: localStorage.getItem('token'),
                                id: initial.id,
                                name: FName,
                                lname: LName,
                                email: Email,
                                phone: Phone,
                                gender: ValGender,
                                image: Image64 ? Image64 : null
                        };
                        const response = await axios.post('employee/profile/update', payload);
                        const resData = response.data.data;
                        navigate('/profile');
                }catch(err){
                        console.error(err);
                        alert('Update failed. Please try again.');
                }finally{
                        setSubmitting(false);
                }
        };

        const getFiles = (e) => {
                const file = e.target.files[0];
                if(!file) return;
                const reader = new FileReader();
                reader.onloadend = function() {
                        setImage64(reader.result);
                        setImage(reader.result);
                }
                reader.readAsDataURL(file);
        };

    return (
        <>
            <div className="container root py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        <div className="d-flex align-items-center mb-3">
                            <button className="btn btn-link text-decoration-none p-0 me-3" onClick={() => navigate(-1)}>
                                <i className="fas fa-arrow-left"></i>
                            </button>
                            <h5 className="mb-0">Edit Profile</h5>
                        </div>

                        <div className="card card-modern mb-3">
                            <div className="card-body">
                                <div className="row g-3">
                                    <div className="col-12 col-md-4 text-center">
                                        <div className="avatar-wrapper mb-3 mx-auto">
                                            <img src={Image || 'https://image.shutterstock.com/image-vector/businessman-avatar-profile-picture-600w-221565274.jpg'} alt="avatar" className="avatar-img"/>
                                        </div>
                                        <div>
                                            <label className="btn btn-outline-secondary btn-sm me-2">
                                                Upload
                                                <input type="file" accept="image/*" onChange={getFiles} hidden />
                                            </label>
                                            <button className="btn btn-light btn-sm" onClick={() => { setImage(''); setImage64(''); }}>
                                                Remove
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-8">
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb-3 form-floating">
                                                <input id="firstName" className="form-control" placeholder="First name" value={FName} onChange={(e) => setFName(e.target.value)} />
                                                <label htmlFor="firstName">First name</label>
                                            </div>

                                            <div className="col-12 col-md-6 mb-3 form-floating">
                                                <input id="lastName" className="form-control" placeholder="Last name" value={LName} onChange={(e) => setLName(e.target.value)} />
                                                <label htmlFor="lastName">Last name</label>
                                            </div>

                                            <div className="col-12 mb-3 form-floating">
                                                <input id="email" type="email" className="form-control" placeholder="Email" value={Email} onChange={(e) => setEmail(e.target.value)} />
                                                <label htmlFor="email">Email</label>
                                            </div>

                                            <div className="col-12 col-md-6 mb-3 form-floating">
                                                <input id="phone" className="form-control" placeholder="Phone" value={Phone} onChange={(e) => setPhone(e.target.value)} />
                                                <label htmlFor="phone">Phone</label>
                                            </div>

                                            <div className="col-12 col-md-6 mb-3">
                                                <label className="small d-block mb-1">Gender</label>
                                                <Select name="gender" options={GenderOption}
                                                    onChange={(opt) => { setGender(opt.label); setValGender(opt.value); }}
                                                    value={ValGender ? { value: ValGender, label: Gender } : null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-grid">
                            <button className="btn btn-brand btn-lg" onClick={submit} disabled={submitting}>
                                {submitting ? (<span className="spinner-border spinner-border-sm me-2"/>) : null} Update profile
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
